import React from 'react';
import CommonPageHeroText from '../../CommonComponents/CommonPageHeroText';
import SectionLayout from '../../CommonComponents/Layout/sectionLayout';
import ChangePasswordForm from './changePasswordForm';
import useLocalization from '../../../Localization';

const ChangePassword = () => {
  const {ApplicationString} = useLocalization();

  return (
    <React.Fragment>
      <CommonPageHeroText
        heading={ApplicationString['userChangePasswordComponent.heading']}
        subheading={ApplicationString['userChangePasswordComponent.subheading']}
      />
      <SectionLayout>
        <ChangePasswordForm />
      </SectionLayout>
    </React.Fragment>
  );
};

export default ChangePassword;
